var Module

// Inside a bounding box check
function TerrierInside(ll,ur,x,y) {
    return ll[0] < x && ll[1] < y && x < ur[0] && y < ur[1];
}

// Test if inside or on edge
function TerrierInsideOrOnEdge(ll,ur,x,y) {
    return ll[0] <= x && ll[1] <= y && x <= ur[0] && y <= ur[1];
}

// Bounding box check
function TerrierInsideOrOnEdgeOneWay(bbA,bbB) {
    return TerrierInsideOrOnEdge([bbA[0],bbA[1]], [bbA[2],bbA[3]], [bbB[0],bbB[1]]) ||
            TerrierInsideOrOnEdge([bbA[0],bbA[1]], [bbA[2],bbA[3]], [bbB[2],bbB[3]]) ||
            TerrierInsideOrOnEdge([bbA[0],bbA[1]], [bbA[2],bbA[3]], bbB[0], bbB[3]) ||
            TerrierInsideOrOnEdge([bbA[0],bbA[1]], [bbA[2],bbA[3]], bbB[2], bbB[1]);
}

// Bounding box check
function TerrierOverlapOneWay(bbA,bbB) {
    return (bbB[0] <= bbA[0] && bbA[2] <= bbB[2] &&
    bbA[1] <= bbB[1] && bbB[3] <= bbA[3]);
}

/** 
 * The Terrier Layer represents a single data layer, like temperature or
 * wind.  Don't create one of these directly, have the TerrierOverlay do it
 * for you with the startLayer() call.  But once you have a TerrierLayer,
 * you can modify it with this object.
 **/
class TerrierLayer {

    /**
     * @hideconstructor
     */
    constructor(layerName,params,ovl) {
        this.name = layerName
        this.ovl = ovl

        if (params == null || params == undefined) {
            params = {}
        }

        this.level = null
        this.colorMap = null
        this.renderScale = 0.5
        this.importScale = 8.0
        this.startupParams = params

        this.setup(params)
    }

    /**
     * This draws an arrow into a canvas and then returns a raw image.
     * Not something you need to be calling, we use it for wind arrows
     */
    drawArrowIntoCanvas() {
        var canvas = document.createElement('canvas');
        canvas.id     = "temp";
        canvas.width  = 190;
        canvas.height = 235;
        canvas.style.zIndex   = 9;
        canvas.style.position = "absolute";
        canvas.style.border   = "0px";
        let ctx = canvas.getContext('2d');
        var path = new Path2D('m0 80 79-80 81 80-14.1 14.1-55.9-55.8v181.7h-20v-181.7l-55.8 55.8z');
        ctx.strokeStyle = "white";
        ctx.lineWidth = 20.0;
        ctx.translate(15.0,-10.0);
        ctx.stroke(path);
        let url = canvas.toDataURL("image/png");
        return url
    }

    // Internal param parsing.  Don't call this.
    setup(params) {
        if (params === undefined) {
            params = {}
        }
        if ('level' in params) {
            this.level = params['level']
        }
        if ('colorMap' in params) {
            this.colorMap = params['colorMap']
        }
        if ('snowColorMap' in params) {
            this.snowColorMap = params['snowColorMap']
        }
        if ('renderScale' in params) {
            this.renderScale = params['renderScale']
        }
        if ('cadence' in params) {
            this.cadence = params['cadence']
        }
        if ('startFrame' in params) {
            this.startFrame = params['startFrame']
        }
        var hasImportScale = false
        if ('importFactor' in params) {
            this.importScale = params['importFactor']
            hasImportScale = true
        }
        if ('arrows' in params) {
            this.arrows = params['arrows']
        }
        if ('loadCallback' in params) {
            this.loadCallback = params['loadCallback']
        }
        this.outputFrameInfo = false
        if ('frameInfo' in params) {
            this.outputFrameInfo = params['frameInfo']
        }
        if ('source' in params) {
            // model, region, type, variable, level
            this.source = params['source']
            if (!this.source['model'] || 
                !this.source['variable']) {
                    console.log("Missing parameters in source description.")
                    return
                }
        }
        if (!('sources' in params)) {
            params['sources'] = Terrier.sourcesFromLayerName(this.name,this.level)
        }
        let jsonSources = params['sources']
        if (jsonSources == undefined || jsonSources.length == 0) {
            console.log("TerrierLayer: No sources set.  Giving up.")
            return
        }
        // Optional temperature sources for reflectivity precip type
        let temperatureJsonSources = params['temperatureSources']

        let dataType = jsonSources[0].dataType
        this.dataType = dataType

        // Note: Need to line up the internal types with what Boxer is publishing
        if (dataType == "velocity") {
            dataType = "WindGust"
        }
        // Note: Need to switch this to a slightly tweaked version
        if (dataType == "preciptype") {
            dataType = "WindGust"
        }

        // Convert to TrrDataSources
        var sources = []
        jsonSources.forEach(jsonSource => {
            let source = new globalThis.Module.TrrDataSource(
                jsonSource.source,
                jsonSource.region,
                jsonSource.product,
                jsonSource.variable,
                jsonSource.level,
                jsonSource.interval,
                jsonSource.temporalType,
                jsonSource.dataType,
                jsonSource.projection,
                jsonSource.depth,
                jsonSource.isGlobal,
                jsonSource.hasMissingValues,
                jsonSource.zeroNoData,
                jsonSource.importanceScale,
            )
            if ('cadence' in jsonSource) {
                let cadence = jsonSource['cadence']
                source.setClipCadence(cadence[0],cadence[1],cadence[2])
            }
            sources.push(source)
        })
        var temperatureSources = null
        if (temperatureJsonSources != undefined && temperatureJsonSources && temperatureJsonSources.length > 0) {
            temperatureSources = []
            temperatureJsonSources.forEach(jsonSource => {
                let source = new globalThis.Module.TrrDataSource(
                    jsonSource.source,
                    jsonSource.region,
                    jsonSource.product,
                    jsonSource.variable,
                    jsonSource.level,
                    jsonSource.interval,
                    jsonSource.temporalType,
                    jsonSource.dataType,
                    jsonSource.projection,
                    jsonSource.depth,
                    jsonSource.isGlobal,
                    jsonSource.hasMissingValues,
                    jsonSource.zeroNoData,
                    jsonSource.importanceScale,
                )
                temperatureSources.push(source)
            })
        }

        // Look for a matching controller state below
        let findControllerState = (name) => {
            for (var key in globalThis.Module.controllerState) {
                if (key.toLowerCase() == name.toLowerCase()) {
                    return globalThis.Module.controllerState[key]
                }
            }
        }

        var foundState = null
        // TODO: Switch to an a/b/c/d endpoint and set this high
        globalThis.Module.numConnections = Terrier.numConnections
        switch (dataType) {
            // Three of these are special
            case "wind_uv":
            case "windUV":
                this.name = "windUV"
                globalThis.Module.enableWind = true
                globalThis.Module.windColorMap = this.colorMap ? this.colorMap : Terrier.WIND_COLORS_NOT_GREY;
                globalThis.Module.windScale = this.renderScale
                globalThis.Module.windCadence = this.cadence
                if (this.level !== null && this.level !== undefined) {
                    globalThis.Module.selectedLevel = this.level
                } else {
                    globalThis.Module.selectedLevel = null
                }
                if (this.startFrame !== null && this.startFrame !== undefined) {
                    globalThis.Module.windStartFrame = this.startFrame
                }
                if (this.loadCallback !== null && this.loadCallback !== undefined) {
                    globalThis.Module.windCallback = this.loadCallback
                }
                if (this.arrows !== null && this.arrows !== undefined) {
                    // Start loading an image and we'll set up the arrows when it arrives
                    var imageUrl
                    if ('image' in this.arrows)
                        imageUrl = this.arrows['image']
                    else
                        imageUrl = this.drawArrowIntoCanvas()
                    // Set up arrows fields
                    var cutoff = 2.57
                    if ('cutoff' in this.arrows) {
                        cutoff = this.arrows['cutoff']
                    }
                    var speed = [2.57, 40.0];
                    if ('speed' in this.arrows) {
                        speed = this.arrows['speed']
                    }
                    var minSize = [5,10]
                    var maxSize = [20,40]
                    if ('size' in this.arrows) {
                        minSize = this.arrows.size[0]
                        maxSize = this.arrows.size[1]
                    }
                    var layout = [100,100]
                    if ('layout' in this.arrows) {
                        layout = this.arrows['layout']
                    }
                    var colors = [0xFF000000,0xFF000000]
                    if ('colors' in this.arrows) {
                        colors = this.arrows['colors']
                    }
                    let windArrows = new globalThis.Module.TrrWindArrows(cutoff, 
                                                            speed[0], speed[1], 
                                                            minSize[0], minSize[1], maxSize[0], maxSize[1],
                                                            layout[0], layout[1],
                                                            colors[0], colors[1], 
                                                            imageUrl)
                    setTimeout(() => {
                        let windControl = findControllerState("winduv")
                        if (windControl) {
                            windControl.controller.setWindArrows(windArrows)    
                            windArrows.delete();                        
                        }
                    }, 0)
                }

                globalThis.Module.windSources = sources
                foundState = findControllerState("winduv")
                break;
            case "temperature":
                globalThis.Module.enableTemp = true
                globalThis.Module.tempColorMap = this.colorMap ? this.colorMap : Terrier.TEMP_COLORS_NOT_GREY;
                globalThis.Module.tempScale = this.renderScale
                globalThis.Module.tempCadence = this.cadence
                if (this.level !== null && this.level !== undefined) {
                    globalThis.Module.selectedLevel = this.level
                } else {
                    globalThis.Module.selectedLevel = null
                }
                if (this.startFrame !== null && this.startFrame !== undefined) {
                    globalThis.Module.tempStartFrame = this.startFrame
                }
                if (this.loadCallback !== null && this.loadCallback !== undefined) {
                    globalThis.Module.tempCallback = this.loadCallback
                }
                globalThis.Module.tempSources = sources
                foundState = findControllerState("temperature")
                break;
            case "radar":
            case "reflectivity":
                globalThis.Module.enableRadar = true
                globalThis.Module.numConnections = 32
                globalThis.Module.radarColorMap = this.colorMap ? this.colorMap : Terrier.RADAR_COLORS_NOT_GREY;
                globalThis.Module.radarCadence = this.cadence
                if (this.level !== null && this.level !== undefined) {
                    globalThis.Module.selectedLevel = this.level
                } else {
                    globalThis.Module.selectedLevel = null
                }
                if (!hasImportScale) {
                    this.importScale = 16.0
                }
                if (this.startFrame !== null && this.startFrame !== undefined) {
                    globalThis.Module.radarStartFrame = this.startFrame
                }
                if (this.loadCallback !== null && this.loadCallback !== undefined) {
                    globalThis.Module.radarCallback = this.loadCallback
                }
                globalThis.Module.radarScale = this.renderScale
                globalThis.Module.radarSources = sources
                if (temperatureSources) {
                    globalThis.Module.tempSources = temperatureSources
                    globalThis.Module.radarSnowColorMap = this.snowColorMap ? this.snowColorMap : Terrier.SNOW_COLORS_NOT_GREY;
                } else
                    globalThis.Module.tempSources = null
                foundState = findControllerState("radar")
                break;
            case "visual":
                globalThis.Module.enableVisual = true
                globalThis.Module.visualCadence = this.cadence
                foundState = findControllerState("visual")
                if (this.startFrame !== null && this.startFrame !== undefined) {
                    globalThis.Module.visualStartFrame = this.startFrame
                }
                if (this.loadCallback !== null && this.loadCallback !== undefined) {
                    globalThis.Module.visualCallback = this.loadCallback
                }
                globalThis.Module.visualSources = sources
                break;
            // And the rest more generic
            // TODO: Pass in the colormap
            default:
                // Look for the controller state
                foundState = findControllerState(dataType)
                if (!foundState) {
                    foundState = findControllerState("Visibility");
                }
                if (!foundState) {
                    console.log("Failed to find layer named " + this.name)
                    return null
                }
                if (this.level !== null && this.level !== undefined) {
                    globalThis.Module.selectedLevel = this.level
                    // foundState.level = this.level
                } else {
                    globalThis.Module.selectedLevel = null                    
                }
                if (this.colorMap !== null && this.colorMap !== undefined) {
                    foundState.colorMap = this.colorMap
                }
                if (this.startFrame !== null && this.startFrame !== undefined) {
                    foundState.startFrame = this.startFrame
                }
                if (this.loadCallback !== null && this.loadCallback !== undefined) {
                    foundState.callback = this.loadCallback
                }
                foundState.cadence = this.cadence
                foundState.renderScale = this.renderScale
                foundState.enabled = true

                break;
        }

        foundState.sources = sources
        this.sources = sources
        this.temperatureSources = temperatureSources
        this.state = foundState

        if (this.cadence) {
            let now = Date.now()
            this.ovl.setTimeRange(now+this.cadence[0]*1000,now+this.cadence[1]*1000)
        }

        // Write out the selected frames for display
        let terrierLayer = this
        globalThis.Module.updateFrameInfo = (selectFrames) => {
            if (terrierLayer.outputFrameInfo) {
                let manifest = selectFrames.manifest
                console.log("Selected frame: " + manifest.source + " " + manifest.region + " " + manifest.product + " " + manifest.variable)
                console.log("  blend: ", selectFrames.interpolation)
                selectFrames.slices.forEach( (slice) => {
                    console.log("  " + "forecastEpoch: " + new Date((slice.forecastEpoch-slice.forecastDelta)*1000).toUTCString() + " delta: " + slice.forecastDelta + "s")
                })
                manifest.delete()
            }
        }

        // This creates the controls if they're not there already
        globalThis.Module.updateOverlay()

        this.setImportanceScale(this.importScale)
        this.updateParams(params)        
    }

    /**
     * If you'd like to change parameters with a dictionary, this is
     * the way to do it.  You can also make direct calls to setInterpMode()
     * and other methods directly.  
     * 
     * For a discussion of what the params dictionary contains, look at the
     * startLayer() method in the TerrierOverlay.
     * @param {Dictionary} params A dictionary of parameters values including 'interpMode', 'opacity' and 'importFactor'.
     */
    updateParams(params) {
        if ('interpMode' in params) {
            this.setInterpMode(params['interpMode'])
        }
        if ('opacity' in params) {
            this.setOpacity(params['opacity'])
        }
        if ('importFactor' in params) {
            this.importScale = params['importFactor']
            this.setImportanceScale(this.importScale)
        }
    }

    /**
     * Some layers have levels. This might be 'sfc' or '5m' or
     * '100m' or something of that sort.  If the layer does have
     * a level, you can set or change it with this.
     * @param {string} newLevel The level to select for this layer.  
     * The data for that level needs to be available from the source.
     */
    setLevel(newLevel) {
        if (this.level != newLevel) {
            this.level = newLevel
            // if (this.state && this.state.controller) {
            //     this.state.controller.level = newLevel
            // }
            this.refresh()
        }
    }

    /*
     * Force a reload of the data layer.  You shouldn't need to
     * call this yourself.
     */
    refresh() {
        if (this.state && this.state.controller) {
            this.state.controller.refresh(null)
        }
    }

    // Don't call this directly.  Use the TerrierOverlay
    stop() {
        if (this.sources) {
            this.sources.forEach(source => {
            // Call shutdown() before delete() to properly release WASM resources
            // and prevent memory leaks when switching between radar layers
            try { source.shutdown(); } catch (e) { }
                source.delete()
            });
            this.sources = undefined
        }
        if (this.temperatureSources) {
            this.temperatureSources.forEach(source => {
                // Call shutdown() before delete() to properly release WASM resources
                try { source.shutdown(); } catch (e) { }
                source.delete()
            });
            this.temperatureSources = undefined
        }
        switch (this.dataType) {
            // Three of these are special
            case "wind_uv":
            case "windUV":
                globalThis.Module.enableWind = false
                break;
            case "temperature":
                globalThis.Module.enableTemp = false
                break;
            case "radar":
            case "reflectivity":
                globalThis.Module.enableRadar = false
                break;
            // And the rest more generic
            case "visual":
                globalThis.Module.enableVisual = false
                break;
            default:
                if (this.state !== null) {
                    this.state.enabled = false
                }
                break;
        }      
        globalThis.Module.updateFrameInfo = null  
    }

    /**
     * Set the interpolation type for data values.  This is how the
     * data is interpolated between cells as it's being rendered into
     * screen space.  This is separate from applying the color map.
     * Set it to nearest if you'd like to see each cell or you have
     * a data type that can't be interpolated (e.g. precip type).
     * Set it to linear to see bilinear interpolation.
     * Set to cubic for bicubic interpolation.
     * @param {string} type Set the interpolation mode to be used for the layer.
     * This can be 'nearest' to see the data cells themselves.
     * It can be 'linear' for bilinear interpolation, which is the default.
     * It can also be 'cubic' for bicubic interpolation, which is costly, but looks
     * very good for data with blobby structures, like radar.
     */
    setInterpMode(type) {
        switch (type) {
            case 'nearest':
                this.state.controller.visInterp = globalThis.Module.TexInterpType.Nearest
                this.state.controller.varInterp = globalThis.Module.TexInterpType.Nearest
                break;
            case 'linear':
                this.state.controller.visInterp = globalThis.Module.TexInterpType.Linear
                this.state.controller.varInterp = globalThis.Module.TexInterpType.Linear
                break;
            case 'cubic':
                this.state.controller.visInterp = globalThis.Module.TexInterpType.Cubic
                this.state.controller.varInterp = globalThis.Module.TexInterpType.Cubic
                break;
        }
        globalThis.Module.repaint()
    }

    /**
     * Terrier is fairly parsimonious with its memory and network bandwidth.  By
     * default it will load a very low resolution of your data.  This is how to
     * make it load more based on the screen resolution.
     * 
     * Internally there is a number called 'importance' that is used to decide when
     * a given data tile will be loaded.  We can tweak that number to make things
     * more important.  Without getting into what it actually means, we use a default
     * of 8.  If you want to force near pixel accuracy try 16 or 32.
     * @param {float} importScale The importance scale, or importFactor (sometimes)
     * to adjust the loading logic.
     */
    setImportanceScale(importScale) {
        if (this.state.controller.minImportanceFactor !== undefined && this.state.controller.minImportanceFactor == importScale) {
            return
        }
        this.state.controller.minImportanceFactor = Number(importScale)
        globalThis.Module.repaint()
    }

    /**
     * Much of the time you're overlaying your data layer on top of a map.  As
     * such you don't want it to be completely opaque and hide the map.  You can
     * control that value here.
     * 
     * 0 is completely transparent and 1 is completely opaque.
     * @param {float} opacity 
     */
    setOpacity(opacity) {
        this.state.controller.opacity = opacity
        globalThis.Module.repaint()
    }

    /**
     * Terrier controls its color maps a TrrShaderColorMap object.  You
     * typically pass in a couple of arrays to do this, one for color
     * and one for value, but those are turned into a TrrShaderColorMap which
     * can be queried.
     * @returns TrrShaderColorMap The color map currently being used by
     * this layer.
     **/
    getColorMap() {
        if (this.colorMap)
            return this.colorMap;
        if (this.state && this.state.controller)
            return this.state.controller.colorMap;
    }

    /**
     * If you'd like to set the color map directly, which you're allowed to
     * do at run time, you can do so here.  The method is expecting a TrrShaderColorMap
     * object which you'll need to set up yourself.
     * @param {TrrShaderColorMap} colorMap The color map to set for this layer.
     */
    setColorMap(colorMap) {
        if (!colorMap) {
            return
        }
        this.colorMap = colorMap
        this.state.controller.colorMap = colorMap
        globalThis.Module.repaint()
    }

    /**
     * If you'd like to set the color map directly, which you're allowed to
     * do at run time, you can do so here.  The method is expecting a TrrShaderColorMap
     * object which you'll need to set up yourself.
     * @param {TrrShaderColorMap} colorMap The color map to set for this layer.
     */
    setSnowColorMap(colorMap) {
        if (!colorMap) {
            return
        }
        this.snowColorMap = colorMap
        this.state.controller.snowColorMap = colorMap
        globalThis.Module.repaint()
    }

    /**
     * Change the cadence (time range and time steps).
     * If the data has already loaded, this will only change the start/end
     * times of the display.
     */
    setCadence(cadence) {
        if (this.state === undefined || this.state.controller === undefined) {
            return
        }
        this.cadence = cadence
        this.state.controller.setCadence(cadence[0],cadence[1],cadence[2])
    }

    /**
     * Query the data value at a given point.
     * 
     * Terrier renders data and turns it into colors (or other displays) at the last
     * stage.  That makes it possible to query the data values at given point and this
     * is how you do that.
     * 
     * Query the data value at a particular screen location.  Coordinates are at full
     * resolution within the OpenGL context.
     * 
     * @param {float} x Horizontal fraction across the OpenGL window, from 0 to 1.
     * @param {float} y Vertical fraction across the OpenGL window, from 0 to 1.
     * @returns A structure containing "value" with one or two values (two for wind) and lon and lat in degrees.
     */
    queryValue(x,y) {
        if (globalThis.Module === undefined || globalThis.Module.canvas === undefined) {
            return null
        }
        var ret = this.state.controller.queryValue(x / globalThis.Module.canvas.width, y / globalThis.Module.canvas.height)
        var loc = this.state.controller.queryLocation(x, y);
        if (!Array.isArray(ret)) {
            ret = [ret]
        }
        if (ret[0] > 1e10) {
            return null
        }
        return {
            // Can return one or more values
            "value": ret,
            "lon": loc[0]*180.0/Math.PI,
            "lat": loc[1]*180.0/Math.PI
        }
    }

    /**
     * Return a geographic location given a point on the screen.
     * Any of the map toolkits can do this for you too, but this is only Terrier dependent.
     * @param {*} x Horizontal location in screen pixels.
     * @param {*} y Vertical location in screen pixels.
     * @returns lon and lat in degrees
     */
    queryLocation(x,y) {
        if (globalThis.Module === undefined || globalThis.Module.canvas === undefined) {
            return null
        }
        var ret = this.state.controller.queryLocation(x, y);
        if (!Array.isArray(ret)) {
            ret = []
        }
        return {
            "lon": loc[0]*180.0/Math.PI,
            "lat": loc[1]*180.0/Math.PI
        }
    }
}

/**
 * Terrier manages its layers through this singleton class.
 * You won't create one of these, but will be given one in the
 * callback for setup from the TerrierModule.
 * 
 * Think of it as the Terrier Overlay on top of your map, whether
 * that's MapLibre or Leaflet or some other.
 * 
 * You can keep the TerrierOverlay around to add and remove layers
 * as needed.
 * @hideconstructor
 */
class TerrierOverlay {
    constructor(terrierModule) {
        this.terrierModule = terrierModule
        this.activeLayers = new Set()
    }
    
    /**
     * Start displaying a layer of the given name/type.  Assuming Terrier recognizes the 
     * name, which will be something like 'temperature', it will fetch the corresponding
     * data manifests and start up the rendering pipeline.
     * 
     * The layerName depends on the contents of your stack and will be something like
     * 'temperature' or 'wind'.  A list of available layer names can be gotten from the
     * fetchStackContents() in the TerrierModule, but you can also hard code those
     * based on what you know is in your stack.  
     * 
     * @param {string} layerName Name of the layer to display, such as 'temperature'.
     * @param {Dictionary} params Parameters that control the display and structural
     * use of the layer.  These include everything you might need to set up the layer
     * including things which can be modified later.  
     * 
     * 'level' selects the level of the data layer, if it has one.  For instance you
     * might have 'sfc', '10m', and '152m' available for 'temperature'.  It depends on
     * your data and you can see the full list from the stack contents, or just hard
     * code it based on what you know is there.  
     * 
     * 'colorMap' sets the color map for the display.  This is a TrrShaderColorMap
     * object which you'll need to create and pass in.  
     * 
     * 'renderScale' sets the scale at which the data is rendered.  Terrier is designed
     * to render data to the screen and then turn that data into colors.  It uses fairly
     * complex shaders to render the data to the screen and will thus try to do less
     * work.  The renderScale is a factor we multiply the WebGL screen size by to
     * downsample the rendering target.  It's 0.25 by default and you can probably leave
     * it alone.  
     * 
     * 'cadence' is an array of 3 values defining the time extents and how many slices of
     * data to load.  The first two arguments are min and max time offsets from now to
     * load for a layer.  The third argument is the number of time slices.  The defaults
     * will be picked up from the stack, so you don't really need to set this, but it
     * can be useful to cut down on loading.  For instance, if you only need the next
     * half hour of data and you know it comes in 5 minute increments you could do:
     * [0,30*60,6].  That will load data from 'now' to a half hour from now and restrict
     * it to at most 6 time slices.
     * 
     * 'importFactor' controls how much data we load for a given area.  Since we're fetching
     * data with a lot of time slices we don't tend to match it pixel for pixel for the screen
     * resolution.  By default this value is 8.  If you want more resolution, set a value up to
     * 32.  If you want less, for some reason, it can go down to 1.
     * 
     * 'startFrame' will set the starting frame to either 'first' or 'last' or 'current.
     * 'current' just sets the current time where 'first' or 'last' will snap to the appropriate
     * frame time.  You would use 'last' for radar, for example to show the most recent radar.
     * 
     * 'arrows' is a set of parameters to control directional arrows for a wind layer.
     * That can contain the following parameters:
     * 'cutoff' in m/s below which no arrow is displayed.
     * 'speed' is a 2 component array of the min and max speed for scaling arrows.
     * 'size' is 2 2 component arrays defining the mix and max size in x and y.
     * 'layout' is a 2 component array defining a grid to lay the arrows out on.
     * 'colors' is a 2 component array of standard 3 component color values (with alpha defined first)
     * that will be used to scale from min to max.
     * 'image' is an optional URL for the PNG you'd like to use rather than our default arrow.
     * 'frameInfo' is an optional bool that will write the current frames being displayed to the console
     * 
     * 'loadCallback' is a Javascript function you pass in that will be called as soon as the 
     * layer has loaded its manifest.  Your function's only argument is the manifest object.
     * The manifest is a JSON return from the Boxer service and it contains everything you
     * might want to know about the data layer you just started.  Of particular use are the
     * timeSlices array which describe the individual time slices the layer can display.
     * From that you can select the forecastEpoch of the first and last slice, for example
     * to set your scrubber to cover only the exact time range available.  This is very useful
     * for radar.
     * 
     * On the visual side you can pass in 'opacity', 'interpMode', and 'importFactor'. Those
     * will call setOpacity(), setInterpMode(), and setImportanceScale(), respectively on
     * startup.
     * 
     * @returns {TerrierLayer} The layer object you can interact with directly to make
     * real-time changes.
     */
    startLayer(layerName,params) {
        // Wrap the layer around the newly updates state
        var layer = new TerrierLayer(layerName,params,this)

        this.activeLayers.add(layer)

        this.checkCanvas()

        return layer
    }

    /**
     * Stop displaying the given layer.  This is the TerrierLayer returned by startLayer().
     * This will not shut down Terrier, however.  You need to do that with the Terrier module.
     * 
     * @param {TerrierLayer} layer The layer to stop displaying.
     */
    stopLayer(layer) {
        if (!this.activeLayers.has(layer)) {
            console.log("Terrier: Tried to delete layer more than once.  Ignoring.");
            return;
        }
        layer.stop()

        this.activeLayers.delete(layer)

        globalThis.Module.updateOverlay()

        this.checkCanvas()
    }

    /**
     * Get the list of currently active layers.  These are all TerrierLayer objects.
     * @returns The list of currently active layers.
     */
    getLayers() {
        if (!this.activeLayers) {
            return []
        }

        return [...this.activeLayers];
    }

    /*
     * If we're using a Javascript canvas for display, we may want to hide that canvas
     * if no layers are currently visible.  We use this in package integrations with
     * things like Leaflet.  You probably don't need to call it directly.
     */
    checkCanvas() {
        if (!Terrier.webglCanvasMode) {
            return
        }
        if (globalThis.Module.canvas != null) {
            if (this.activeLayers.size == 0) {
                globalThis.Module.canvas.style.visibility = "hidden"
            } else {
                globalThis.Module.canvas.style.visibility = "visible"
            }
        }
    }

    /**
     * You can add a bit of GeoJSON over top of the map.  This is largely here
     * for debugging as you probably have a good way to do that with the base 
     * map toolkit.
     * 
     * @param {json} geojson The JSON object for GeoJSON.
     */
    addGeoJSON(geojson) {
        globalThis.Module.overlay.addGeoJSON(geojson)
    }

    /**
     * Returns the current time being displayed (in seconds from the 1970 epoch), rather
     * than the current wall clock time.
     * @returns {float}
     */
    getCurrentTime() {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return 0.0 }

        return globalThis.Module.tracker.curTime / 1000.0
    }

    /**
     * Set the displayed time (in seconds from the 1970 epoch).  This is the time Terrier
     * will use for calculating the display and is separate from wall clock time.
     * @param {float} epoch Seconds since the 1970 epoch.
     */
    setCurrentTime(epoch) {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return }
        // TODO: Cache this if there's no Module yet

        if (globalThis.Module.tracker.curTime != epoch) {
            globalThis.Module.tracker.curTime = epoch * 1000.0
            globalThis.Module.repaint()
        }
    }

    /**
     * Nearest frame mode means we snap to the nearest frame time when setting
     * the value (and tracker) for display.
     * 
     * @returns Return true if nearest frame mode is on
     */
    getNearestFrame() {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return true; }
        return globalThis.Module.tracker.nearestFrame
    }

    /**
     * Nearest frame mode means we snap to the nearest frame time when setting
     * the value (and tracker) for display.
     * 
     * @param {double} nearFrame 
     */
    setNearestFrame(nearFrame) {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return }

        globalThis.Module.tracker.nearestFrame = nearFrame
    }

    /**
     * Returns the minimum and maximum times available from the data currently loaded.
     * Times are in seconds from the 1970 epoch.
     * @returns An array of 2 floats describing the min and max time.
     */
    getTimeRange() {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return [0.0,0.0] }
        return [globalThis.Module.tracker.minTime, globalThis.Module.tracker.maxTime]
    }

    /**
     * Set the min and max epoch (time in ms since 1970) for the current display.
     */
    setTimeRange(minEpoch,maxEpoch) {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return }
        globalThis.Module.tracker.setRange(minEpoch,maxEpoch)
    }
    
    /**
     * Terrier likes to control animation itself, rather than depend on an outside
     * app to smoothly run through a time range with setCurrentTime().  The way
     * this works is you call this method and it will start animating.  Then
     * periodically query the current time with getCurrentTime() and update
     * your own controls from that.
     * @param {Dictionary} params This dictionary contains values which control
     * the animation.  
     * 
     * 'period' the number of wall clock seconds to animate from the start of
     * the time range to the end of it.
     * 
     * 'pause' is the number of wall clock seconds to pause at the end of the
     * animation before wrapping around to the start.
     */
    timePlay(params) {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return }

        if (!params) {
            params = {}
        }

        if ('period' in params) {
            globalThis.Module.setPlayInterval(params['period'])
        }
        if ('pause' in params) {
            globalThis.Module.setPauseInterval(params['pause'])
        }

        globalThis.Module.play()  
    }

    /**
     * If Terrier is animating the data over time, this returns true.
     */
    isTimePlaying() {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return false }

        return globalThis.Module.tracker.isPlaying
    }

    /**
     * Pause the time animation if it's running.  This does nothing if Terrier is
     * already paused.
     */
    timePause() {
        if (globalThis.Module === undefined || globalThis.Module.tracker === undefined) { return }

        globalThis.Module.pause()
    }

    // Update the transform used to move the map around
    // Don't call this unless you know you should, as
    //  it's pretty different between toolkits
    updateTransform(lon, lat, zoom, worldSize, transMat) {
        if (globalThis.Module == undefined) { return }
        globalThis.Module.transform = {
            centerLng: lon,
            centerLat: lat,
            zoom: zoom,
            scale: zoom,
            worldSize: worldSize, 
            projMatrix: transMat
        }
        // console.log("lon = " + lon)
        // console.log("lat = " + lat)
        // console.log("zoom = " + zoom)
        // console.log("projMatrix = " + transMat)
        if (globalThis.Module.repaint !== undefined) {
            globalThis.Module.repaint()
        }
    }
}

/**
 * This is the module logic for Terrier and it's where you'll go to
 * start the toolkit running.  If you're overlaying on Leaflet, us the
 * startLeaflet() method to kick off display.  For MapLibre, use
 * startMapLibre().
 * 
 * You won't create one of these, we do that when the JS file is loaded.
 * Then you access the TerrierModule through the 'Terrier' global variable.
 * You use the start methods as defined above and call stop() when you
 * want Terrier to destroy all of its rendering infrastructure. 
 */
class TerrierModule {
    /**
     * @hideconstructor
     */
    constructor() {
        // Developers interface to Terrier through the 'overlay'
        this.ovl = new TerrierOverlay(this)
        this.isReady = false
        this.numConnections = 8
        this.webglCanvasMode = false
    }

    // Interpolation type for layers
    InterpType = {
        Nearest: 'nearest',
        Linear: 'linear',
        Bicubic: 'bicubic',
    };

    // Wire in the global colormaps
    setupColorMaps() {
        Terrier.TEMP_COLORS_GREY = Terrier.createColorMap([255.372, 316.483], [0xFF000000, 0xFFFFFFFF]);
        Terrier.TEMP_COLORS_NOT_GREY = Terrier.createColorMap(
            [255.372, 260.928, 266.483, 272.039, 277.594, 283.15, 288.706, 294.261, 299.817, 305.372, 310.928, 316.483],
            [0xFFFFBFFF, 0xFFD873DB, 0xFF913ABB, 0xFF372398, 0xFF00B6DC, 0xFF02D786, 0xFF40C604, 0xFFFFFF00, 0xFFFB7700, 0xFFD22402, 0xFFA20902, 0xFFEED9D8]);
        Terrier.WIND_COLORS_GREY = Terrier.createColorMap([0, 40], [0xFF000000, 0xFFFFFFFF]);
        Terrier.WIND_COLORS_NOT_GREY = Terrier.createColorMap(
        [0, 5, 10, 15, 20, 25, 30, 35, 40],
            [0xFFAED5FF, 0xFF86B4E6, 0xFF66E2D6, 0xFF00CC05, 0xFFECF006, 0xFFFF6B00, 0xFFE11511, 0xFFE111C1, 0xFFFFCEF7]);
        const MeterstoKnots = 0.514444
        Terrier.WIND_NOAA = Terrier.createColorMap(
            [0*MeterstoKnots, 5*MeterstoKnots, 
             5*MeterstoKnots, 10*MeterstoKnots,
             10*MeterstoKnots, 15*MeterstoKnots, 
             15*MeterstoKnots, 20*MeterstoKnots,
             20*MeterstoKnots, 25*MeterstoKnots, 
             25*MeterstoKnots, 30*MeterstoKnots,
             30*MeterstoKnots, 35*MeterstoKnots, 
             35*MeterstoKnots, 40*MeterstoKnots,
             40*MeterstoKnots, 45*MeterstoKnots,
             45*MeterstoKnots, 50*MeterstoKnots,
             50*MeterstoKnots, 55*MeterstoKnots,
             55*MeterstoKnots, 60*MeterstoKnots,
             60*MeterstoKnots, 65*MeterstoKnots,
             65*MeterstoKnots, 70*MeterstoKnots,
             70*MeterstoKnots, 75*MeterstoKnots,
             75*MeterstoKnots, 80*MeterstoKnots,
             80*MeterstoKnots, 85*MeterstoKnots,
             85*MeterstoKnots, 90*MeterstoKnots,
             90*MeterstoKnots
             ],
            [0x0000000, 0x00f8d4f9,
             0xfff8d4f9, 0xfff8d4f9,
             0xfff1a5f4, 0xfff1a5f4,
             0xffe074f1, 0xffe074f1,
             0xff0045ff, 0xff0045ff,
             0xff0099ff, 0xff0099ff,
             0xff00ceff, 0xff00ceff,
             0xff00e8ff, 0xff00e8ff,
             0xff07ffe6, 0xff07ffe6,
             0xff66d400, 0xff66d400,
             0xff80fa04, 0xff80fa04,
             0xffb4ff36, 0xffb4ff36,
             0xffeaff13, 0xffeaff13,
             0xffffe501, 0xffffe501,
             0xffffc808, 0xffffc808,
             0xfffe8708, 0xfffe8708,
             0xffff3300, 0xffff3300,
             0xffff0139, 0xffff0139,
             0xfff704fc
            ]);

        Terrier.RADAR_COLORS_GREY = Terrier.createColorMap([-30, 5, 70], [0x00000000, 0xFF111111, 0xFFFFFFFF]);
        Terrier.RADAR_COLORS_NOT_GREY = Terrier.createColorMap([
        -30, -25, -20, -15, -10, -5, 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75
        ], [
            0xFFAAAAAA,   // Not actually present in the data
            0xFF000000,   // "
            0x11FFFFFF,   // Data present but no returns
            0x4410E6E7, 0x7710E6E7, 0xBB10E6E7, // Not visible either
            0xFF10E6E7, 0xFF10E6E7, 0xFF069FF3, 0xFF0400F0, 0xFF01FC08, 0xFF02C701, 0xFF068D01, 0xFFF6F602, 
            0xFFE6BA03, 0xFFF79505, 0xFFFE0002, 0xFFD60401, 0xFFBB0200, 0xFFF807F6, 0xFF9A52C8, 0xFFFCFBFA,
        ], [
            false, false, false,
            false, false, false,
            true, true, true, true, true, true,
            true, true, true, true, true, true, true, true,
            true, true, true, true, true, true, true, true
        ]);
        Terrier.SNOW_COLORS_NOT_GREY = Terrier.createColorMap([
        -30, -25, -20, -15, -10, -5, 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75
        ], [
            0x00000000,   // Not actually present in the data
            0x00000000,   // "
            0x00FFFFFF,   // Data present but no returns
            0x00cffcfc, 0x00cffcfc, 0xBBcffcfc, // Not visible either
            0xFFcffcfc, 0xFFcffcfc, 0xFFcdedfe, 0xFFcdccff, 0xFFccffce, 0xFFccffcc, 0xFFceffcc, 0xFFfefecd, 
            0xFFfef4cd, 0xFFfeeacd, 0xFFFE0002, 0xFFffcccc, 0xFFffcdcc, 0xFFfecdfe, 0xFFe9d8f3, 0xFFece6df,
        ], [
            false, false, false,
            false, false, false,
            true, true, true, true, true, true,
            true, true, true, true, true, true, true, true,
            true, true, true, true, true, true, true, true
        ]);
        Terrier.WEATHER_COLORS = Terrier.createColorMap([
            // Fair, Rain, Mix, Snow, Sleet, Freezing Rain, Severe, Thunderstorm, Hail = 8, HIWIND = 9
            // SVRWND = 10, BLZRD = 11, ICING = 12, ICEFOG = 13, FZFOG = 14, FOG = 15, WINDY = 16
            // HAZE = 17, MIST = 18, FZDZ = 19, DRZL = 20, BLSNOW = 21, FIREWX = 22, XHEAT = 23, XCOLD = 24, UNKNOWN
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26
        ], [
            0x00000000, // Fair
            0xFF009100, // Rain
            0xFFa01a93, // Mix
            0xFF124e82, // Snow
            0xFFffbe71, // Sleet
            0xFFf98407, // Freezing Rain
            0xFFe4333d, // Severe
            0xFFff00ff, // thunrderstorm
            0xFF950000, // Hail = 8
            0xFF777777, // HIWIND = 9
            0xFF777777, // SVRWND = 10
            0xFF777777, // BLZRD = 11
            0xFF777777, // ICING = 12
            0xFF777777, // ICEFOG = 13
            0xFF777777, // FZFOG = 14
            0xFF777777, // FOG = 15
            0xFF777777, // WINDY = 16
            0xFF777777, // HAZE = 17
            0xFF777777, // MIST = 18
            0xFF777777, // FZDZ = 19
            0xFF777777, // DRZL = 20
            0xFF777777, // BLSNOW = 21
            0xFF777777, // FIREWX = 22
            0xFF777777, // XHEAT = 23
            0xFF777777, // XCOLD = 24
            0xFF777777, // SMOKE = 25
            0xFFff00ff  // Unknown
        ], [
            false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true
        ]);
        Terrier.REFLECTIVITY_HRRR_COMPATIBLE = Terrier.createColorMap([
            -30, -25, -20, -15, -10, -5, 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75
            ], [
                0x00000000,   // Not actually present in the data
                0x00000000,   // "
                0x00FFFFFF,   // Data present but no returns
                0x0010E6E7, 0x0010E6E7, 0xBB10E6E7, // Not visible either
                0xFF10E6E7, 0xFF10E6E7, 0xFF069FF3, 0xFF0400F0, 0xFF01FC08, 0xFF02C701, 0xFF068D01, 0xFFF6F602, 
                0xFFE6BA03, 0xFFF79505, 0xFFFE0002, 0xFFD60401, 0xFFBB0200, 0xFFF807F6, 0xFF9A52C8, 0xFFFCFBFA,
            ], [
                false, false, false,
                false, false, false,
                true, true, true, true, true, true,
                true, true, true, true, true, true, true, true,
                true, true, true, true, true, true, true, true
            ]);
        // Convert to mm/hr: 0.036 x 10^(0.0625 x dBZ)
        Terrier.RAINFALL_RATE = Terrier.createColorMap([
            0, 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75
            ].map((dbz) => { return 0.036 * Math.pow(10.0,0.0625*dbz) }), [
                0x0010E6E7,
                0xFF10E6E7, 0xFF10E6E7, 0xFF069FF3, 0xFF0400F0, 0xFF01FC08, 0xFF02C701, 0xFF068D01, 0xFFF6F602, 
                0xFFE6BA03, 0xFFF79505, 0xFFFE0002, 0xFFD60401, 0xFFBB0200, 0xFFF807F6, 0xFF9A52C8, 0xFFFCFBFA
            ], [
                true, true, true, true, true, true, true, true,
                true, true, true, true, true, true, true, true
            ]);
        Terrier.SEVERE_HAIL_INDEX_COLORS = Terrier.createColorMap(
            [0, 5, 10, 20, 30, 40, 50, 60, 80, 100, 150, 250, 500, 1500],
            [0x0006ecec, 0xff00a0f6, 0xff0600f6, 0xff01ff00, 0xff00c801, 0xff009000, 
                0xffffff04, 0xffe7c102, 0xffff9100, 0xffff0100, 0xffc00100, 0xffff01ff, 0xffbe55dc, 0xff7e32a7]);
        Terrier.PROB_SEVERE_HAIL_COLORS = Terrier.createColorMap(
            [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            [0x0006ecec, 0xff00a0f6, 0xff0600f6, 0xff01ff00, 0xff00c801, 
                0xff009000, 0xffffff04, 0xffe7c102, 0xffff9100, 0xffff0100, 0xffff0100]);
        Terrier.DEGREE_COLORS = Terrier.createColorMap(
            [0, 72, 144, 216, 288, 360],
            [0xFF2A52BD, 0xFF0088DD, 0xFFFFD301, 0xFFFF8B01, 0xFFC23B21, 0xFFA40001]);
        let feetToMm = 25.4;
        Terrier.HAIL_SIZE_COLORS = Terrier.createColorMap(
            [0.0*feetToMm, 0.05*feetToMm, 0.1*feetToMm, 0.15*feetToMm, 0.20*feetToMm, 0.25*feetToMm, 0.40*feetToMm, 
                0.5*feetToMm, 0.6*feetToMm, 0.75*feetToMm, 1.0*feetToMm, 1.5*feetToMm, 2.0*feetToMm, 3.0*feetToMm, 4.0*feetToMm],
            [0x0006ecec, 0xff06ecec, 0xff00a0f6, 0xff0600f6, 0xff01ff00, 0xff00c801, 0xff009000, 
                0xffffff04, 0xffe7c102, 0xffff9100, 0xffff0100, 0xffc00100, 0xffff01ff, 0xfffffbe5, 0xff7e32a7]);                
        Terrier.QPE_FFG_RATIO_COLORS = Terrier.createColorMap(
            [0.0, 0.1, 0.2, 0.4, 0.6, 0.8, 1.0, 1.2, 1.4, 1.6, 1.8, 2.00, 2.25, 2.50, 2.75, 3.00, 3.50, 4.00, 5.00],
            [0xffbebebe, 0xff8c8c8c, 0xff6e6e6e, 0xff505050, 0xff01b500, 0xff009b01, 
                0xffffff04, 0xffffe102, 0xffffc802, 0xffffb400, 0xffffa100, 0xffb40100, 0xffc80200, 
                0xffe20100, 0xffff0100, 0xffff01ff, 0xffd300d2, 0xffaa00ab, 0xff800080]);                
        Terrier.PRECIP_FLAG_COLORS = Terrier.createColorMap(
            [0, 1, 2, 3, 4, 5, 6, 7],
            [0x00000000, 0xFFffffff, 0xFF960096, 0xFFff3332, 0xFF0350a5, 0xFF6effff, 0xff00ff00, 0xff00ff00]);
        Terrier.TURBULENCE_COLORS = Terrier.createColorMap(
            [0, .10, .20, .30, .40, .50, .60, .70, .80, .90, 1.00],
            [0x00000000, 0xFFd0fffe, 0xFFcbff06, 0xFFfacf00, 0xFFffa100, 0xFFff6800, 0xFFfb0c00, 0xFFcf0000, 0xFF9e0000, 0xFF6f0001, 0xFF220206]);
        Terrier.CLOUD_COVER = Terrier.createColorMap(
            [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            [0xFF7db4ff, 0xFF81bcfc, 0xFF90c0ff, 0xFFa6c9fe, 0xFFbfd8fd, 0xFFc0d9fd, 0xFFb3c0d6, 0xFFa7aeb3, 0xFFa5acb1, 0xFF919191, 0xFF888888]);
        Terrier.CLOUD_COVER = Terrier.createColorMap(
            [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            [0xFF7db4ff, 0xFF81bcfc, 0xFF90c0ff, 0xFFa6c9fe, 0xFFbfd8fd, 0xFFc0d9fd, 0xFFb3c0d6, 0xFFa7aeb3, 0xFFa5acb1, 0xFF919191, 0xFF888888]);


        // A placeholder for an index value we haven't made a proper colormap for yet
        Terrier.INDEXPLACE_COLORS_NOT_GREY = Terrier.createColorMap(
            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            [0xFF0000FF, 0xFFFF0000, 0xFF00FF00, 0xFFFFFF00, 0xFF00FFFF, 
                0xFF0000FF, 0xFFFF0000, 0xFF00FF00, 0xFFFFFF00, 0xFF00FFFF,
                0xFF0000FF, 0xFFFF0000, 0xFF00FF00, 0xFFFFFF00, 0xFF00FFFF,
                0xFF0000FF, 0xFFFF0000, 0xFF00FF00, 0xFFFFFF00, 0xFF00FFFF,
                0xFFFFFFFF]);

        let feetToMeters = 1/3.28084
        Terrier.CLOUD_COLORS_NOT_GREY = Terrier.createColorMap(
            [0.0*feetToMeters,500.0*feetToMeters,
            500.0*feetToMeters,900.0*feetToMeters,
            900.0*feetToMeters,1000.0*feetToMeters,
            1000.0*feetToMeters,3000.0*feetToMeters,
            3000.0*feetToMeters,4000.0*feetToMeters,
            4000.0*feetToMeters,
            5000.0*feetToMeters,6000.0*feetToMeters,
            6000.0*feetToMeters
            ],
            [0xff800000,0xffE63222,
            0xffFFFF55,0xffFFFF55,
            0xffED702E,0xffED702E,
            0xff01007B,0xff01007B,
            0xff75FB4C,0xff75FB4C,
            0xff75FB4C,
            0xff2A6318,0xff2A6318,
            0x00000000
            ])
        let hfeetToMeters = 100.0/3.28084
        Terrier.CLOUD_CEILING2 = Terrier.createColorMap(
            [0.0*hfeetToMeters,1*hfeetToMeters,2*hfeetToMeters,3*hfeetToMeters,4*hfeetToMeters,5*hfeetToMeters,6*hfeetToMeters,7*hfeetToMeters,8*hfeetToMeters,9*hfeetToMeters,
             10*hfeetToMeters,1.*hfeetToMeters,14*hfeetToMeters,16*hfeetToMeters,18*hfeetToMeters,
             20*hfeetToMeters,22*hfeetToMeters,24*hfeetToMeters,26*hfeetToMeters,28*hfeetToMeters,
             30*hfeetToMeters,35*hfeetToMeters,

             40.0*hfeetToMeters,
             50.0*hfeetToMeters,
             60.0*hfeetToMeters,
             80.0*hfeetToMeters,
             100.0*hfeetToMeters,
             140.0*hfeetToMeters,
             180.0*hfeetToMeters,
             220.0*hfeetToMeters,
             260.0*hfeetToMeters,
             300.0*hfeetToMeters,
            ],
            [0xFF5D0E63,0xFF8C1A94,0xFFBB27C6,0xFFEA33F7,0xFFF19EFA,0xFFA02015,0xFFEA3323,0xFFEC5B29,0xFFEE8044,0xFFF3AE3D,      
             0xFFE6E687,0xFFFBE779,0xFFFFFF79,0xFFFFFF65,0xFFFEF852,
             0xFF91FCFE,0xFF68E0FB,0xFF469DF8,0xFF255AF6,0xFF0600F5,
             0xFF1D4A0F,
             0xFF215112,

             0xFF1D4A0F,
             0xFF1D4A0F,
             0xFF215112,
             0xFF275D16,
             0xFF30701D,
             0xFF3A8424,
             0xFF44982A,
             0xFF4EAC31,
             0xFF57BF38,
             0xFFFFFFFF
            ])
        let statMileToMeters = 1609.34
        Terrier.VISIBILITY_COLORS_NOT_GREY = Terrier.createColorMap(
            [0*statMileToMeters,1*statMileToMeters,
            1*statMileToMeters,3*statMileToMeters,
            3*statMileToMeters,5*statMileToMeters,
            5*statMileToMeters,
            7*statMileToMeters,
            8*statMileToMeters,9*statMileToMeters,
            9*statMileToMeters
            ],
            [0xff800000,0xff800000,
            0xffE63222,0xffE63222,
            0xffFFFF55,0xffFFFF55,
            0xff75FB4C,
            0xff3A8323,
            0xff113208,0xff113208,
            0x00000000
            ])
        Terrier.VISIBILITY2 = Terrier.createColorMap(
            [0.0*statMileToMeters,0.2*statMileToMeters,0.4*statMileToMeters,0.6*statMileToMeters,0.8*statMileToMeters,
             1.0*statMileToMeters,1.4*statMileToMeters,1.8*statMileToMeters,
             2.2*statMileToMeters,2.6*statMileToMeters,
             3.0*statMileToMeters,3.9*statMileToMeters,
             4.0*statMileToMeters,4.1*statMileToMeters,4.2*statMileToMeters,4.3*statMileToMeters,4.4*statMileToMeters,4.5*statMileToMeters,4.6*statMileToMeters,4.7*statMileToMeters,4.8*statMileToMeters,4.9*statMileToMeters,
             5.0*statMileToMeters,5.5*statMileToMeters,
             6.0*statMileToMeters,
             7.0*statMileToMeters,
             8.0*statMileToMeters,
             9.0*statMileToMeters,9.9*statMileToMeters,
             10.0*statMileToMeters
            ],
            [0xFF5D0E63,0xFF8C1A94,0xFFBB27C6,0xFFEA33F7,0xFFF19EFA,
             0xFFA02015,0xFFEA3323,0xFFEC5B29,
             0xFFEE8044,0xFFF3AE3D,
             0xFFE6E687,0xFFA02015,
             0xFF91FCFE,0xFF74FBFD,0xFF68E0FB,0xFF57BEF9,0xFF469DF8,0xFF367BF7,0xFF255AF6,0xFF0616F5,0xFF0600F5,0xFF1D4AF6,
             0xFF1E4B10,0xFF255915,
             0xFF30701D,
             0xFF44982A,
             0xFF58C038,
             0xFF6CE846,0xFF77FC4C,
             0x00000000
            ])
        Terrier.ICING = Terrier.createColorMap(
            [0,1,1,2,3,4,5],
            [0x00000000,0x00D8FDFD,0xFFD8FDFD,0xFFA4CCFB,0xFF7398F8,0xFF3334F3,0xFFEF8582]
        )
        Terrier.PERCENT_COLORS_NOT_GREY = Terrier.createColorMap(
            [0.0,100.0],
            [0x00666666,0xff666666]
        )
        Terrier.PERCENT_COLORS_WARN = Terrier.createColorMap(
            [0.0,5.0,
                5.0,10,
                10,20,
                20,30,
                30,40,
                40,50,
                50,60,
                60,70,
                70,80,
                80,90,
                90,100],
            [0x00000000,0x00008C00,
             0xff008C00,0xff008C00,
             0xff00C800,0xff00C800,
             0xff00FF00,0xff00FF00,
             0xffFFFF00,0xffFFFF00,
             0xffE0C26A,0xffE0C26A,
             0xffA56E2A,0xffA56E2A,
             0xffFFA500,0xffFFA500,
             0xffFF0000,0xffFF0000,
             0xff8C0000,0xff8C0000,
             0xffFF00FF,0xffFF00FF
            ]
        )
        Terrier.TIME_CLEAR_COLORS = Terrier.createColorMap(
            [0.0,1*60,
                1*60,6*60,
                6*60,12*60,
                12*60,18*60,
                18*60,24*60,
                24*60,30*60,
                30*60,36*60,
                36*60,42*60,
                42*60,48*60,
                48*60,54*60,
                54*60,60*60],
            [0x00000000,0x00008C00,
             0xff008C00,0xff008C00,
             0xff00C800,0xff00C800,
             0xff00FF00,0xff00FF00,
             0xffFFFF00,0xffFFFF00,
             0xffE0C26A,0xffE0C26A,
             0xffA56E2A,0xffA56E2A,
             0xffFFA500,0xffFFA500,
             0xffFF0000,0xffFF0000,
             0xff8C0000,0xff8C0000,
             0xffFF00FF,0xffFF00FF
            ]
        )
        let hgToPa = 3386.39
        Terrier.PRESSURE_COLORS_NOT_GREY = Terrier.createColorMap(
            [29.9*hgToPa,30.4*hgToPa],
            [0x00666666,0xff666666]
        )
        Terrier.LIGHTNING_FIRST_STRIKE = Terrier.createColorMap(
            [0.0,60*0.001,
                60*0.001,60*15,
                60*15,60*20,
                60*20,60*25,
                60*25,60*30,
                60*30,60*35,
                60*35,60*40,
                60*40,60*45,
                60*45,60*50,
                60*50,60*55,
                60*55,60*60,
                60*60,60*100],
            [0x00000000,0xffa80000,
                0xffa80000,0xffa80000,
                0xff901848,0xff901848,
                0xff4818a8,0xff4818a8,
                0xff1848ff,0xff1848ff,
                0xff1890f0,0xff1890f0,
                0xff00c0c0,0xff00c0c0,
                0xff60d860,0xff60d860,
                0xff90d848,0xff90d848,
                0xffc0d878,0xffc0d878,
                0xfff0d878,0xfff0d878,
                0x00f0d878,0x00f0d878]
        )
        Terrier.LIGHTNING_ALL_CLEAR = Terrier.createColorMap(
            [0.0,60*1.0,
                60*1.0,60*1.5,
                60*1.5,60*2.0,
                60*2.0,60*2.5,
                60*2.5,60*3.0,
                60*3.0,60*3.5,
                60*3.5,60*4.0,
                60*4.0,60*4.5,
                60*4.5,60*5.0,
                60*5.0,60*5.5,
                60*5.5,60*6,
                60*6,60*10],
            [0x00000000,0x00000000,
                0xffa8a800,0xffa8a800,
                0xfff0d878,0xfff0d878,
                0xffc0d878,0xffc0d878,
                0xff90d848,0xff90d848,
                0xff60d860,0xff60d860,
                0xff00c0c0,0xff00c0c0,
                0xff1890f0,0xff1890f0,
                0xff1848ff,0xff1848ff,
                0xff4818a8,0xff4818a8,
                0xff901848,0xff901848,
                0xffa80000,0xffa80000
            ])
        Terrier.RED_TO_GREEN_PERCENT = Terrier.createColorMap(
            [0.0,
             10.0,
             30.0,
             50.0,
             60.0,
             70.0,
             100.0],
            [0xffD61F1F,
             0xffD61F1F,
             0xffE03C32,
             0xffFFD301,
             0xff7BB662,
             0xff639754,
             0xff006B3D
            ]),

        Terrier.RADIATION_FLUX = Terrier.createColorMap(
            [0.0,500.0],
            [0xff666666,0xffffffff]    
        )

        Terrier.AIRQUALITYINDEX = Terrier.createColorMap(
            [0.0,50.0,
                50.0, 100.0,
                100.0, 150.0,
                150.0, 200.0,
                200.0, 300.0,
                300.0, 500.0
            ],
            [0xff05e300,0xff05e300,
                0xffffff00,0xffffff00,
                0xffff7e00,0xffff7e00,
                0xffff0100,0xffff0100,
                0xff8f3f97,0xff8f3f97,
                0xff7e0123,0xff7e0123,
            ]    
        )

        Terrier.AEROSOLTYPE = Terrier.createColorMap(
            [0.0,
             2,
             15,
             30,
             45,
             60,
             75,
             90,
             105,
             120,
             135,
             150,
             165,
             180,
             195,
             210,
             225,
             240
            ],
            [0x00000000,
                0xff090ce2,
                0xff090ce2,
                0xff0751ff,
                0xff0099ff,
                0xff4bc3ff,
                0xff67ddff,
                0xff81f2ff,
                0xff99f8ff,
                0xffc2ffff,
                0xffffff3d,
                0xffffeb00,
                0xffffc100,
                0xffff8900,
                0xffff2f00,
                0xffff0000,
                0xffe90000,
                0xffae0000
               ]    
           )

           Terrier.UVINDEX = Terrier.createColorMap(
            [
             1,
             2,
             3,
             4,
             5,
             6,
             7,
             8,
             9,
             10,
             11
            ],
            [0xff279500,
                0xff279500,
                0xfff7e400,
                0xfff7e400,
                0xfff7e400,
                0xfff85900,
                0xfff85900,
                0xffd80211,
                0xffd80211,
                0xffd80211,
                0xff6b49c8
               ]    
           )

            Terrier.SMOKE = Terrier.createColorMap(
            [0.0, 1,
             1, 4,
             4, 7,
             7, 11,
             11, 15,
             15, 20,
             20, 25,
             25, 30,
             30,40,
             40, 50,
             50, 75,
             75, 150,
             150, 250,
             250, 500,
             500
            ],
            [0x00000000, 0x00000000,
                0xffd0e2f3, 0xffd0e2f3,
                0xff94c4df, 0xff94c4df,
                0xff4998c9, 0xff4998c9,
                0xff1564ab, 0xff1564ab,
                0xff108446, 0xff108446,
                0xff55b45f, 0xff55b45f,
                0xffa2d86a, 0xffa2d86a,
                0xfffff7b0, 0xfffff7b0,
                0xfffcab5f, 0xfffcab5f,
                0xfff7844e, 0xfff7844e,
                0xffed5f3d, 0xffed5f3d,
                0xffc21d27, 0xffc21d27,
                0xffa50026, 0xffa50026,
                0xffa50026
               ]    
           )

        }

    /**
     * We use a TrrShaderColorMap object to set and query colormaps, but
     * you don't have to create those directly.  Instead, use this convenience
     * method to do it.  Pass in your array of data values and corresponding
     * colors.  Those need to both be the same length.
     * @param {Array.float} values An array of data values to use in the color map.
     * These are actual data values in the proper units.  That may be Kelvin for temperature,
     * and so forth.  These map directly to the colors array for a given value.
     * @param {Array.int} colors An array of numbers corresponding to RGBA colors.
     * We like to use hex definitions of the form 0xAARRGGBB where A is alpha, R is red,
     * G is green and B is blue.  These are standard in CSS and you can find a good
     * converter online to map from your favorite color system to hex values.
     * @returns TrrShaderColorMap
     */
    createColorMap(values, colors, visibles) {
        if (values.length != colors.length) {
            console.log("createColorMap: Values and colors array must be same length.")
            return
        }
        if (visibles !== undefined) {
            return new globalThis.Module.TrrShaderColorMap(0, false, values, colors, visibles)
        } else {
            return new globalThis.Module.TrrShaderColorMap(0, false, values, colors)
        }
    }

    // Internal setup logic
    setupModule(initFunc, readyFunc) {
        // console.log("setupModule() called.")
        Terrier.initFunc = initFunc
        Terrier.readyFunc = readyFunc

        // Already initialized the module, so just call them back
        if ('Module' in globalThis) {
            if ('_initMap' in globalThis) {
                // Set onOverlayInitialized BEFORE calling initFunc, because
                // initFunc calls _initMapLibre which may synchronously call onAdd (when style
                // is already loaded), and onAdd checks for this callback. If we set it after
                // initFunc returns, the callback is missed on re-initialization after stop().
                if (readyFunc) {
                    if (!Terrier.isReady) {
                        globalThis.Module.onOverlayInitialized = function() {
                            Terrier.isReady = true
                            if (readyFunc !== undefined) {
                                // Let things settle a beat and then let the dev get set up
                                setTimeout( () => {Terrier.readyFunc(Terrier.ovl) }, 0)
                            }
                            globalThis.Module.onOverlayInitialized = null
                        }        
                    } else {
                        // Let things settle a beat and then let the dev get set up
                        setTimeout( () => {Terrier.readyFunc(Terrier.ovl) }, 0)
                    }
                }
                // This is the normal case where the Module is properly set up
                if (initFunc !== undefined) {
                    Terrier.initFunc()
                }
            } else {
                // This happens if they somehow do two start-map actions in a row
                // The right thing will happen here which is the new initFunc and readyFunc will be called
            }

            return
        }

        // Emscripten is expecting this global Module to be defined
        //  and it will merge these contents with its own
        globalThis.Module = {
            preRun: [],
            postRun: [],
            emInitialized: false, // Set when the Emscripten runtime is loaded
            doMapInit: true,      // MapLibre not currently deferred, can we do that?
            noInitialRun: true,   // don't call main
            noExitRuntime: true,  // Keep the Emscripten runtime from shutting down after async
            // calls because we aren't using the main loop mechanism.
            autoRepaint: 2000,    // draw a frame every few seconds even if nothing changed
            debugLayers: false,
            debugTracker: false,
            debugJSFetch: false,
            debugTemp: false,
            debugWind: false,
            debugRadar: false,
            numConnections: Terrier.numConnections,

            print: (function () {
                return function (text) {
                    if (arguments.length > 1) text = Array.prototype.slice.call(arguments).join(' ');
                    text = text.replace(/&/g, "&amp;");
                    text = text.replace(/</g, "&lt;");
                    text = text.replace(/>/g, "&gt;");
                    text = text.replace('\n', '<br>', 'g');
                    console.log(text);
                };
            })(),
            setStatus: function (text) {
                //console.log("Module.setStatus: '" + text + "'");
            },
            totalDependencies: 0,
            monitorRunDependencies: function (left) {
                //console.log("Module.monitorRunDependencies(" + left + ")");
            },
            onRuntimeInitialized: function () {
                Terrier.setupColorMaps()
                        
                // console.log("Runtime Initialized");
                if (window.mobile) {
                    const text = document.getElementById("frameText");
                    text.innerHTML = "Mobile not supported";
                    text.setAttribute("rows", 2);
                    text.classList.add("active");
                    return;
                }
                globalThis.Module.emInitialized = true;
                _postLoadInit();

                globalThis.Module.service = new globalThis.Module.TrrService();
                globalThis.Module.service.stackName = Terrier.stackName;
                globalThis.Module.service.apiKey = Terrier.apiKey;
                globalThis.Module.service.apiVersion = 2;
                globalThis.Module.tempCadence = [-24 * 3600, 24 * 3600, 40];
                globalThis.Module.windCadence = [-25 * 3600, 24 * 3600, 40];
                globalThis.Module.radarCadence = [-2 * 3600, 0 * 3600, 40];

                if (globalThis.Module.doMapInit) {
                    Terrier.initFunc()
                }
            },
            onOverlayInitialized: function() {
                Terrier.isReady = true
                // console.log("onOverlayInitialized called")
                if (readyFunc !== undefined) {
                    // console.log("onOverlayInitialized calling readyFunc")
                    // Let things settle a beat and then let the dev get set up
                    setTimeout( () => {Terrier.readyFunc(Terrier.ovl) }, 0)
                }
                globalThis.Module.onOverlayInitialized = null
            }
        };        
    }

    libraryLoaded = false

    // Internal setup logic
    loadLibrary() {
        if (!this.libraryLoaded) {
            // console.log("loadLibrary() called")
            // Have the main WhirlyGlobe web module load itself
            //  this also kicks off Emscriten
            var s = document.createElement('script');
            s.type = 'text/javascript';
            // Note: May cause problems if you need an absolute path
            s.src = 'WhirlyGlobeWeb.js';
            s.defer = 'defer';
            document.body.appendChild(s);            
            this.libraryLoaded = true
        }
    }

    /**
     * Given a variable, usually returned from a call to Terrier,
     * we will try to figure out what colormap might work for it.
     * You can always substitute your own, these are just default.
     * 
     * @param {Dictionary} variable 
     * @returns A trrColorMap you can pass to the Layer creation.
     */
    colorMapForVariable(variable) {
        if (variable.name == 'weather') {
            return Terrier.WEATHER_COLORS;
        }
        if (variable.source == 'flashwx') {
            switch (variable.name) {
                case "lightning_probability":
                case "lightning_probability_extended":
                    return Terrier.PERCENT_COLORS_WARN;
                case "lightning_firststrike":
                    return Terrier.LIGHTNING_FIRST_STRIKE;
                case "lightning_allclear":
                    return Terrier.LIGHTNING_ALL_CLEAR;
                case "golf_playability_index":
                    return Terrier.RED_TO_GREEN_PERCENT;
            }
        }
        if (variable.source == 'airnow') {
            switch (variable.name) {
                case "forecasted_air_quality_index":
                    case "air_quality_index":
                    return Terrier.AIRQUALITYINDEX;
            }
            switch (variable.units) {
                case "ug/m3":
                    return Terrier.AEROSOLTYPE;
            }
        }
        switch (variable.name.toLowerCase()) {
            case "uv_index":
                return Terrier.UVINDEX;
            case "cloud_cover":
                return Terrier.CLOUD_COVER;
            case "icing_severity":
                return Terrier.ICING;
        }
        if (variable.name.toLowerCase().includes("cloud_cover")) {
                return Terrier.CLOUD_COVER;            
        }
        if (variable.name.toLowerCase().includes("precipitation_rate")) {
                return Terrier.RAINFALL_RATE;            
        }
        if (variable.name == 'column_integrated_smoke') {
            return Terrier.SMOKE;
        }
        if (variable.units) {
            switch(variable.units.toLowerCase()) {
                case "w/m^2":
                    return Terrier.RADIATION_FLUX
                case "degrees":
                    return Terrier.DEGREE_COLORS;
            }
        }

        switch (variable.dataType.toLowerCase()) {
            case "reflectivity":
                return Terrier.REFLECTIVITY_HRRR_COMPATIBLE;
            case "temperature":
                return Terrier.TEMP_COLORS_NOT_GREY;
            case "wind_uv":
            case "velocity":
                return Terrier.WIND_NOAA;
            case "probability":
                if (variable.name == "probability_severe_hail") {
                    return Terrier.PROB_SEVERE_HAIL_COLORS;
                }
            case "percentage":
                if (variable.name.includes('lightning')) {
                    return Terrier.PERCENT_COLORS_WARN;
                }
                return Terrier.PERCENT_COLORS_NOT_GREY;
            case "visibility":
                return Terrier.VISIBILITY2;
            case "cloudceiling":
                return Terrier.CLOUD_CEILING2;
            case "preciptype":
                return Terrier.PRECIP_FLAG_COLORS;
            case "severehailindex":
                return Terrier.SEVERE_HAIL_INDEX_COLORS;
            case "size":
                return Terrier.HAIL_SIZE_COLORS;
            case "pressure":
                return Terrier.PRESSURE_COLORS_NOT_GREY;
            case "turbulence":
                return Terrier.TURBULENCE_COLORS;
            case "none":
                if (variable.name.includes("hail_swath")) {
                    return Terrier.HAIL_SIZE_COLORS;
                }
                // The way dataType is set up isn't quite right.
                if (variable.name.includes("qpe_ffg")) {
                    return Terrier.QPE_FFG_RATIO_COLORS;
                }
            case "time":
                return Terrier.TIME_CLEAR_COLORS;
            default:
                return Terrier.INDEXPLACE_COLORS_NOT_GREY
        }
    }

    /**
     * If the variable is an enumerated type, this will
     * return a list of strings for that enumerated type.
     * 
     * @param {Dictionary} variable 
     * @returns A list of strings.
     */
    enumValuesForVariable(variable) {
        if (variable.name == 'weather') {
            return ['Fair', 'Rain', 'Mixed', 'Snow', 'Sleet', 'Freezing Rain', 'Severe', 'Thunderstorm',
                    'Hail', 'Extreme Wind', 'Severe Wind', 'Blizzard', 'Icing', 'Ice Fog', 'Freezing Fog',
                    'Fog', 'Very Windy', 'Haze', 'Mist', 'Freezing Drizzle', 'Drizzle', 'Blowing Snow',
                    'Fire Weather', 'Heat Advisory', 'Extreme Cold', 'Smoke', 'Unknown']
        }

        return []
    }

    /**
     * Boxer stacks know what is in them and we can ask for that information to figure
     * out which layers to display and what levels they may have.  We don't get that
     * information by default, but if you ask for it, Terrier will fetch it and
     * call you back with the results.  
     * 
     * The return data is JSON and looks like this:
     * ```
     * {"<src>" :  
     *    {"<region>":  
     *     {"<products>": [],  
     *      "<levels>": [],  
     *      "temporalType": "observed", "forecast", "both",  
     *      "dataType": "wind_uv", "wind_speed", "wind_speed_gust", "temperature",  
     *                  "radar", "precip_rate", "precip_type", "cloud_cover", "cloud_ceiling",  
     *                  "pressure", "visibility"}}}
     * ```
     *
     * Using this is by no means required.  It's useful if you have a lot of flexible
     * data and obviously we like it for monitoring what's going in a stack.  But
     * if you already know your variable names (e.g. temperature) then you can
     * just use those.
     * 
     * @param {function} fetchFunc After the contents have been fetched from Boxer,
     * Terrier will call this function back with those JSON results.
     * @param {function} failFunc If the contents fetch fails for some reason,
     * this function will be called back with that information.
     */
    fetchStackContents(fetchFunc, failFunc) {
        // TODO: We'll move this into the stack at some point
        var endpoint = ''
        if (this.stackName.includes('localhost')) {
            endpoint = "http://" + this.stackName
        } else {
            if (this.stackName.includes('http')) {
                endpoint = this.stackName
            } else {
                endpoint = "https://"+this.stackName+".api.wetdogweather.com"
            }
        }
        // console.log("fetchStackContents() called")

        let outie = this;
        setTimeout( () => {
            if (outie.shuttingDown) {
                // console.log("fetchStackContents() short circuited by shuttingDown")
                return
            }
            fetch(endpoint + "/manifest/v2/getvisualvarkeys",
                  {headers: {'Authorization': 'Bearer ' + Terrier.apiKey,
                             'Access-Control-Request-Method': 'GET'
                            }}
                )
                .then((response) =>  {
                    if (response.ok) {
                        return response.json()
                    } else {
                        console.log("fetchStackContents() fetch failed")
                        failFunc()
                    }
                })
                .then((data) => {
                    // Note: We're going to do a little hacking here to fix some older stacks
                    data.sources.forEach( source =>
                        source.regions.forEach( region =>
                            region.products.forEach( product =>
                                product.variables.forEach( variable => {
                                    if (variable.dataType == 'visibility' || variable.name == 'cloud_ceiling') {
                                        variable.hasEmptyVals = true
                                    }
                                    if (source.name == 'mrms') {
                                        variable.hasEmptyVals = true
                                        variable.zeroNoData = true
                                    }
                                    if (source.name == 'ndfd') {
                                        variable.hasEmptyVals = true
                                        variable.zeroNoData = false
                                    }
                                    if (variable.temporalType == '' || source.name == 'flashwx') {
                                        variable.temporalType = 'both'
                                    }
                                    if (source.name == 'airnow' && variable.name.includes('particulate')) {
                                        variable.hasEmptyVals = false
                                    }
                                }
                                )
                            )
                        )            
                        )
                    Terrier.stackContents = data
                    if (!outie.shuttingDown) {
                        // console.log("fetchStackContents() calling fetchFunc()")
                        fetchFunc(Terrier.stackContents)
                    }
                })
            },0)
    }

    // Search through the stack contents to return all the various levels for a variable
    //  among all the sources
    /**
     * Search through the stack contents and return all the various levels for a given
     * variable.  For example you might pass in 'temperature' and get back ['sfc','10m','152m'].
     * The actual list depends on your stack and data and you need to have already called
     * fetchStackContents() at least once.
     * @param {string} dataType Data type to get the levels for.
     * @returns {Array.string} Levels supported for the data type
     */
    variableLevelsForStack(dataType) {
        var levels = new Set([])
        if (!this.stackContents) {
            return Array.from(levels)
        }
        this.stackContents.sources.forEach( source =>
            source.regions.forEach( region =>
                region.products.forEach( product =>
                    product.variables.forEach( variable => {
                            if (variable.dataType.toLowerCase() == dataType) {
                                variable.levels.forEach( (level) => {
                                    levels.add(level)
                                })
                            }
                        }
                    )
                )
            )            
         )

        return Array.from(levels)
    }

    /**
     * The unique variable types for a given stack.  This is essentially all
     * the layerNames you might pass in when starting a new layer.
     * For purely visual layers, we tack 'visual' on the front of the name.
     * @returns {Dict} All the valid layer names for a stack with values that describe the variable.
     */
    variablesForStack() {
        var variables = {}
        if (!this.stackContents) {
            return Array.from(variables)
        }
        this.stackContents.sources.forEach( source =>
            source.regions.forEach( region =>
                region.products.forEach( product =>
                    product.variables.forEach( variable => {
                            variable.source = source
                            if (variable.dataType == 'visual') {
                                variables['visual ' + variable.name + ' ' + source.name] = variable
                            } else {
                                variables[variable.name] = variable
                            }
                        }
                    )
                )
            )            
         )

        return variables
    }

    /**
     * Returns a list of region names available in the stack.
     * These can be used to filter variables later.
     */
    regionsForStack() {
        var regions = new Set([])
        if (!this.stackContents) {
            return Array.from(regions)
        }
        this.stackContents.sources.forEach( source =>
            source.regions.forEach( region =>
                regions.add(region.name)
            )            
         )        
         return Array.from(regions)
    }

    /**
     * Returns a list of sources available in the stack.  These can be
     * used to filter in other query functions.
     */
    sourcesForStack() {
        var sources = new Set([])
        if (!this.stackContents) {
            return Array.from(sources)
        }
        this.stackContents.sources.forEach( source =>
            sources.add(source.name)
         )        
         return Array.from(sources)
    }

    /**
     * Construct a list of sources that match certain criteria.  These can be source,
     * region, or product which can take a list of string or one or no strings to match.
     * The variable entry must be set as this is the variable you'll match to from 
     * all available sources.
     * level can be set, as can interval, but only to one string.  If none is provided
     * and the source has multiple of those, we'll just pick the first.
     * You can also pass in an optional 'bounds' which is a bounding box of four floats
     * of the form [lon, lat, lon lat].  Only overlapping regions will be returned.
     * 
     * The simplest example is to pass in {variable: 'temperature', level: '2m'} and you'll
     * get a list of 2m temperature for all sources.
     * 
     * You can also just pass in a string for params and we'll turn that into a proper search.
     *  
     * @param {Dictionary} params A dictionary optionally containing match parameters, but must have 'variable'
     * @returns A list of disambiguated sources to add to a display.
     */
    sourcesForVariable(params) {        
        var sources = new Array()
        if (!this.stackContents) {
            return sources
        }
        if (typeof params == "string") {
            params = {'variable': params}
        }
        if (!('variable' in params)) {
            console.log("Must at least match to variable name in sourcesForVariable.")
            return
        }
        var variableMatch = params['variable']
        if (typeof variableMatch != "string") {
            console.log("Must specify variable as single string.")
            return
        }
        var sourceMatch = 'source' in params ? params['source'] : null
        if (typeof sourceMatch == "string") {
            sourceMatch = [sourceMatch]
        }
        var regionMatch = 'region' in params ? params['region'] : null
        if (typeof regionMatch == "string") {
            regionMatch = [regionMatch]
        }
        var boundsMatch = 'bounds' in params ? params['bounds'] : null
        var productMatch = 'product' in params ? params['product'] : null
        if (typeof productMatch == "string") {
            productMatch = [productMatch]
        }
        var levelMatch = 'level' in params ? params['level'] : null
        var intervalMatch = 'interval' in params ? params['interval'] : null
        this.stackContents.sources.forEach( source => {
            var sourceMatched = true
            if (sourceMatch) {  
                sourceMatched = false
                sourceMatch.forEach( match => {
                    if (match.toLowerCase() == source.name.toLowerCase()) {
                        sourceMatched = true
                    }
                })              
            }

            if (sourceMatched) {
                source.regions.forEach( region => {
                    var regionMatched = true
                    if (regionMatch) {  
                        regionMatched = false
                        regionMatch.forEach( match => {
                            if (match.toLowerCase() == region.name.toLowerCase()) {
                                regionMatched = true
                            }
                        })              
                    }
                    
                    var boundsMatched = true
                    if (boundsMatch) {
                        boundsMatched = TerrierInsideOrOnEdgeOneWay(region.geobounds, boundsMatch) ||
                                        TerrierInsideOrOnEdgeOneWay(boundsMatch, region.geobounds) ||
                                        TerrierOverlapOneWay(region.geobounds, boundsMatch) ||
                                        TerrierOverlapOneWay(boundsMatch, region.geobounds)
                    }
                    if (regionMatched && boundsMatched) {
                        for (const product of region.products) {
                            var productMatched = true
                            if (productMatch) {  
                                productMatched = false
                                productMatch.forEach( match => {
                                    if (match.toLowerCase() == product.name.toLowerCase()) {
                                        productMatched = true
                                    }
                                })              
                            }    

                            if (productMatched) {
                                var foundVariable = false
                                product.variables.forEach( variable => {
                                    var variableMatched = true
                                    if (variableMatch) {  
                                        variableMatched = false
                                        if (variableMatch.toLowerCase() == variable.name.toLowerCase()) {
                                            variableMatched = true
                                        }
                                    }    
                                    if (variableMatched) {
                                        var levelMatched = true
                                        var levelName = variable.levels.length > 0 ? variable.levels[0] : "none"
                                        if (levelMatch) {
                                            levelMatched = false
                                            variable.levels.forEach(level => {
                                                if (levelMatch.toLowerCase() == level.toLowerCase()) {
                                                    levelMatched = true
                                                    levelName = levelMatch.toLowerCase()
                                                }
                                            })
                                        }
                                        var intervalMatched = true
                                        var intervalName = variable.intervals.length > 0 ? variable.intervals[0] : "none"
                                        if (intervalMatch) {
                                            intervalMatched = false
                                            variable.intervals.forEach(interval => {
                                                if (intervalMatch.toLowerCase() == interval.toLowerCase()) {
                                                    intervalMatched = true
                                                    intervalName = intervalMatch.toLowerCase()
                                                }
                                            })
                                        }
                                        if (levelMatched && intervalMatched) {
                                            foundVariable = true
                                            var newVar = {
                                                source: source.name,
                                                region: region.name,
                                                product: product.name,
                                                name: variable.name,
                                                variable: variable.name,
                                                level: levelName,
                                                levels: variable.levels,
                                                interval: intervalName,
                                                temporalType: variable.temporalType,
                                                dataType: variable.dataType,
                                                units: variable.units,
                                                depth: variable.bits,
                                                isGlobal: region.isglobal,
                                                hasMissingValues: variable.hasEmptyVals,
                                                zeroNoData: variable.zeroNoData,
                                                importanceScale: 1.0,
                                                drawOrder: source.order,
                                                enableForRange: [false,false]
                                            }
                                            if (variable.projection) {
                                                newVar.projection = variable.projection
                                            } else {
                                                newVar.projection = ""
                                            }
                                            sources.push(newVar)
                                        }
                                    }
                                })

                                if (foundVariable) {
                                    break
                                }
                            }
                        }
                    }
                })            
            }
        })

        sources.sort((a, b) => a.drawOrder - b.drawOrder);

        return sources
    }

    /**
     * Pass in a generic name like 'windUV' or 'temperature' and we'll pass back
     * a direct list of sources to display.  These are the more generic names we
     * used to use before we switched over to a list of sources from the stack.
     * @param {string} layerName 
     */
    sourcesFromLayerName(layerName,level) {
        var params = {}
        if (level !== undefined) {
            params['level'] = level
        }
        switch (layerName) {
            case "wind_uv":
            case "windUV":
                params['variable'] = 'wind_uv'
                break;
            case "temperature":
                params['variable'] = 'temperature'
                break;
            case "radar":
                break;
            case "visual":
                // TODO: Fix this one
                break;
            default:
                params['variable'] = layerName
                break;
        }
        return this.sourcesForVariable(params)
    }
    
    /**
     * Normally you pass in the stack name on startup and then use just that
     * stack.  This will let you point to another stack.  As a developer, you
     * probably won't use this, but we do use it in our testing.
     * 
     * @param {string} stackName Name of the stack to use.  This is provided
     * to you as a developer.  Your company will typically have one production
     * and one development stack.
     * @param {function(TerrierOverlay): void} readyFunc Once we've communicated with the stack, Terrier
     * calls this function back with the TerrierOverlay object.  You can use that start
     * and stop layers.
     * @param {function(): void} failedFunc If the stack can't be reached, for whatever
     * reason, we call this function with no arguments.
     */
    changeStack(stackName, apiKey, readyFunc, failedFunc) {
        // If they call it too early, just ignore it
        if (!this.isReady) { return }
        if (this.stackName == stackName) { return }
        if (typeof apiKey !== 'string') {
            console.log("apiKey must be set to string")
            return
        }
        if (apiKey) {
            this.apiKey = apiKey
        }
        this.stackName = stackName
        globalThis.Module.service.stackName = Terrier.stackName;
        globalThis.Module.service.apiKey = Terrier.apiKey;

        this.fetchStackContents( () => {
            readyFunc(Terrier.ovl)
        }, 
        () => {
            failedFunc()
        })
    } 

    /**
     * If you're using Leaflet as your base map package, this is the method
     * to call to kick off Terrier.  The system does a lot on initialization,
     * including load its WebAssembly and start up WebGL.  Call this when
     * you're ready to go and have the canvas layer from Leaflet.
     * 
     * @param {string} stackName Name of the Boxer stack you're communicating with.
     * You'll typically have one production and one development stack as an enterprise
     * user.
     * @param {Canvas} canvasLayer The Canvas layer to attach to within Leaflet.
     * See the Leaflet example for details on this.
     * @param {function(TerrierOverlay): void} readyFunc When Terrier is properly initialized it will
     * call this function back with the TerrierOverlay you can use to start new
     * layer displays.
     */
    startLeaflet(stackName, apiKey, canvasLayer, readyFunc) {
        this.stackName = stackName
        if (typeof apiKey !== 'string') {
            console.log("apiKey must be set to string")
            return
        }
        this.apiKey = apiKey

        // Already started, so just call them back
        this.shuttingDown = false;
        if (this.isReady) {
            if (readyFunc !== undefined) {
                readyFunc(this.ovl)
            }
            return
        }

        if (canvasLayer == undefined) {
            console.log('Need to pass the mapCanvas into TerrierInit.  Not starting.')
            return
        }
        this.webglCanvasMode = true

        // Wire ourselves into the canvas layer delegate
        canvasLayer.delegate({
            onLayerDidMount() {
                Terrier.fetchStackContents( () => {
                    Terrier.setupModule(() => {
                        if (!canvasLayer._canvas || !_initMap) {
                            console.log("Failed to start on Leaflet canvas.  Skipping.")
                            return
                        }
                        _initMap("webglcanvas", canvasLayer._canvas)
                    }, readyFunc)
                    globalThis.Module.canvas = canvasLayer._canvas,

                    Terrier.loadLibrary()
                }, 
                () => {
                    console.log("Failed to fetch stack contents.  Terrier will not start.")
                })        
            },
        
            onDrawLayer(info) {
                var px = canvasLayer._map.getPixelBounds()
                let far = 10.0
                let near = -10.0
                var transform = [2.0/(px.max.x-px.min.x), 0.0, 0.0, 0.0,  
                                0.0, -2.0/(px.max.y-px.min.y), 0.0, 0.0,  
                                0.0, 0.0, -2.0/(far-near), 0.0,
                                -(px.max.x+px.min.x)/(px.max.x-px.min.x), (px.max.y+px.min.y)/(px.max.y-px.min.y), -(far+near)/(far-near), 1.0]
                var geoCenter = canvasLayer._map.getCenter()
                Terrier.ovl.updateTransform(geoCenter.lng, geoCenter.lat, info.zoom, 0.0, transform)
            }
        })        
    }

    /**
     * If Terrier has a layer in a MapLibre map, you can get a handle to it here.
     * This will be null if the MapLibre map style has not yet loaded or the
     * Terrier layer is not present.
     * 
     * This is useful if you need to reorder the layer.
     */
    getMapLibreLayer() {
        if ('Module' in globalThis && 'maplibreLayer' in globalThis.Module){
            return globalThis.Module.maplibreLayer;
        }

        return null;
    }

    /**
     * If you're using MapLibre as your base map package, this is the method
     * to call to kick off Terrier.  The system does a lot on initialization,
     * including load its WebAssembly.  
     * 
     * MapLibreGL (and MapboxGL) integration is very smooth since
     * both the base toolkit and Terrier are using WebGL.  If you have a choice,
     * this is the better integration to use.
     * 
     * @param {string} stackName Name of the Boxer stack you're communicating with.
     * You'll typically have one production and one development stack as an enterprise
     * user.
     * @param {maplibreMap} maplibreMap The main MapLibre object.  See the MapLibre
     * example for details.
     * @param {function(TerrierOverlay): void} readyFunc When Terrier is properly initialized it will
     * call this function back with the TerrierOverlay you can use to start new
     * layer displays.
     * @param belowLayer If set, we'll ask MapLibre to put our new layer below this one.
     * Typically this lets you put the weather below the labels.
     */
    startMapLibre(stackName, apiKey, maplibreMap, readyFunc, belowLayer) {
        this.stackName = stackName
        if (typeof apiKey !== 'string') {
            console.log("apiKey must be set to string")
            return
        }
        this.apiKey = apiKey
        if (maplibreMap == undefined) {
            console.log('Need to pass the MapLibre map into TerrierInit.  Not starting.')
            return
        }
        this.shuttingDown = false
        // console.log("startMapLibre() called")

        // Already started, so just call them back
        if (this.isReady) {
            if (readyFunc !== undefined) {
                // console.log("startMapLibre() calling readyFunc directly")
                readyFunc(this.ovl)
            }
            return
        }

        this.fetchStackContents( () => {
            // console.log("startMapLibre() fetchStackContents() callback called")
            this.setupModule(() => {
                // console.log("startMapLibre() setupModule() callback called")
                if (belowLayer === undefined) {
                    _initMapLibre(maplibreMap)
                } else {
                    _initMapLibre(maplibreMap,belowLayer)
                }
            }, readyFunc)
            this.loadLibrary()
        },
        () => {
            console.log("Failed to fetch stack contents.  Terrier will not start.")
        })
    }

    /**
     * If you're using ArcGIS Maps SDK for JavaScript as your base map package, this is the method
     * to call to kick off Terrier.  The system does a lot on initialization,
     * including load its WebAssembly.  
     * 
     * ArcGIS Maps SDK integration is very smooth since
     * both the base toolkit and Terrier are using WebGL.
     * 
     * @param {string} stackName Name of the Boxer stack you're communicating with.
     * You'll typically have one production and one development stack as an enterprise
     * user.
     * @param {Map} arcgisMap The main Map object.  See the ArcGISMaps example
     * for details.
     * @param {function(TerrierOverlay): void} readyFunc When Terrier is properly initialized it will
     * call this function back with the TerrierOverlay you can use to start new
     * layer displays.
     */
    startArcGIS(stackName, apiKey, arcGISMapView, readyFunc) {
        this.stackName = stackName
        if (typeof apiKey !== 'string') {
            console.log("apiKey must be set to string")
            return
        }
        this.apiKey = apiKey
        if (arcGISMapView == undefined) {
            console.log('Need to pass the ArcGIS map into TerrierInit.  Not starting.')
            return
        }

        // Already started, so just call them back
        if (this.isReady) {
            if (readyFunc !== undefined) {
                readyFunc(this.ovl)
            }
            return
        }

        this.fetchStackContents( () => {
            this.setupModule(() => {
                _initArcGIS(arcGISMapView)
            }, readyFunc)
            this.loadLibrary()
        },
        () => {
            console.log("Failed to fetch stack contents.  Terrier will not start.")
        })
    }

    /**
     * If you're using OpenLayer to display your map, this is the method
     * to call to kick off Terrier.  The system does a lot on initialization,
     * including load its WebAssembly.  
     * 
     * @param {string} stackName Name of the Boxer stack you're communicating with.
     * You'll typically have one production and one development stack as an enterprise
     * user.
     * 
     * @param {*} openLayersMap The main OpenLayer Map object.  See the OpenLayers example for details.
     * 
     * @param {*} canvasLayer You'll need to create a RealtimeCanvasLayer and pass it in.  This is the shim
     * we use to insert ourselves into OpenLayers.  Consult the example to see how to create one.
     * 
     * @param {*} readyFunc When Terrier is properly initialized it will
     * call this function back with the TerrierOverlay you can use to start new
     * layer displays.
     */
    startOpenLayers(stackName, apiKey, openLayersMap, canvasLayer, readyFunc) {
        this.stackName = stackName
        if (typeof apiKey !== 'string') {
            console.log("apiKey must be set to string")
            return
        }
        this.apiKey = apiKey
        if (openLayersMap == undefined || canvasLayer == undefined) {
            console.log('Need to pass the OpenLayers map and the canvasLayer into TerrierInit.  Not starting.')
            return
        }

        // Already started, so just call them back
        this.shuttingDown = false;
        if (this.isReady) {
            if (readyFunc !== undefined) {
                readyFunc(this.ovl)
            }
            return
        }
        this.webglCanvasMode = true

        let outie = this;
        Terrier.fetchStackContents( () => {
            Terrier.setupModule(() => {
                if (!canvasLayer._canvas || !_initMap) {
                    console.log("Failed to start on OpenLayers canvas.  Skipping.")
                    return
                }
                _initMap("webglcanvas", canvasLayer._canvas)
            }, readyFunc)
            globalThis.Module.canvas = canvasLayer._canvas;

            // We want the option to draw every frame even if we don't need it
            let triggerRedraw = function() {
                if (globalThis.Module && globalThis.Module.overlay && globalThis.Module.overlay.hasChanges()) {
                    openLayersMap.render();
                }
                if (!outie.shuttingDown) {
                    requestAnimationFrame(triggerRedraw);
                }
            };
            requestAnimationFrame(triggerRedraw);

            Terrier.loadLibrary()
        }, 
        () => {
            console.log("Failed to fetch stack contents.  Terrier will not start.")
        })        

        // Wire ourselves into the canvas layer delegate
        canvasLayer.delegate({
            onRender(frameState) {
                let extents = openLayersMap.getView().calculateExtent(openLayersMap.getSize());
                let worldExtents = openLayersMap.getView().getProjection().getExtent()
                let worldWidth = worldExtents[2] - worldExtents[0]
                let scale = 1.0

                let far = 10.0
                let near = -10.0
                var transform = [2.0/(scale*(extents[2]-extents[0])), 0.0, 0.0, 0.0,  
                                0.0, 2.0/(scale*(extents[3]-extents[1])), 0.0, 0.0,  
                                0.0, 0.0, -2.0/(far-near), 0.0,
                                -(scale*(extents[2]+extents[0]))/(scale*(extents[2]-extents[0])), -(scale*(extents[3]+extents[1]))/(scale*(extents[3]-extents[1])), -(far+near)/(far-near), 1.0]
                var geoCenter = frameState.centerLonLat
                
                Terrier.ovl.updateTransform(geoCenter[0], geoCenter[1], openLayersMap.getView().getZoom(), worldWidth, transform)
            }
        })        
    }


    /**
     * If you want Terrier completely stopped, this is what you can call.
     * If you want to shutdown a layer, just call the corresponding method
     * on the TerrierOverlay.
     */
    stop() {
        this.shuttingDown = true
        if (!('Module' in globalThis)) {
            console.log("Terrier.stop() called but Terrier was not set up.")
            return
        }

        // console.log("Terrier.stop() called")
        globalThis.Module.enableWind = false
        globalThis.Module.enableTemp = false
        globalThis.Module.enableRadar = false
        globalThis.Module.enableVisual = false
        for (var key in globalThis.Module.controllerState) {
            globalThis.Module.controllerState[key].enabled = false
            // Properly delete controller to avoid WASM memory leaks
            const ctl = globalThis.Module.controllerState[key].controller;
            if (ctl) {
                try {
                    ctl.stop(null);
                    ctl.delete();
                } catch (e) { console.warn('Error deleting controller:', e); }
            }
            globalThis.Module.controllerState[key].controller = null
        }

        // Clear controller references (already deleted above via controllerState)
        globalThis.Module.radarCtl = null;
        globalThis.Module.windCtl = null;
        globalThis.Module.tempCtl = null;
        globalThis.Module.visualCtl = null;

        // Stop all active layers to release WASM resources
        if (this.ovl) {
            this.ovl.getLayers().forEach(l => {
                try {
                    this.ovl.stopLayer(l);
                } catch (error) {
                    console.warn('Error stopping layer during cleanup:', error);
                }
            });
            this.ovl.activeLayers.clear();
        }

        // Delete the tracker to free WASM memory
        if (globalThis.Module.tracker) {
            try {
                globalThis.Module.tracker.delete();
            } catch (e) { console.warn("Error deleting tracker", e); }
            globalThis.Module.tracker = null;
        }
    
        if (this.webglCanvasMode) {
            _shutdownWebglCanvas()
        }
        _stopWhirlyGlobe()
        this.isReady = false
    }

};

if (!('Terrier' in globalThis)) {
    var Terrier = new TerrierModule()
}

/**
 * This is the main access to the Terrier module.  Once you've loaded the terrier.js
 * file, just access Terrier through this.
 */
export default Terrier;